module.exports = __webpack_public_path__ + "r-v3/img/icon-bar-graph_on.6c37bae2.svg";